'use client'

import Script from 'next/script'
import { useEffect } from 'react'

export default function StaticPage() {
  const timestamp = Date.now()

  useEffect(() => {
    const hideNavigation = () => {
      document.querySelector('main').classList.add('ve-styling')

      const nav = document.querySelector('header')
      if (nav) {
        nav.style.display = 'none'
      }

      const floatingContacts = document.querySelectorAll('.floatingButtons')
      floatingContacts.forEach((el) => {
        el.classList.add('ve-hideElement')
      })
    }

    const bodyContainer = document.querySelectorAll('.radix-themes')
    bodyContainer.forEach((el) => {
      el.classList.add('veBackgroundColor')
    })

    const showNavigation = () => {
      document.querySelector('main').classList.remove('ve-styling')

      const nav = document.querySelector('header')
      if (nav) {
        nav.style.display = ''
      }

      const floatingContacts = document.querySelectorAll('.floatingButtons')
      floatingContacts.forEach((el) => {
        el.classList.remove('ve-hideElement')
      })
    }

    const updateVueAffix = () => {
      const vueAffixElements = document.querySelectorAll('.vue-affix')

      vueAffixElements.forEach((el) => {
        el.classList.add('vue-affix-fixed')
        el.classList.remove('affix-top-fixed')
      })

      const vueAffixTop = document.querySelectorAll('.affix-top')

      vueAffixTop.forEach((el) => {
        el.classList.add('affix-top-fixed')
        el.classList.remove('vue-affix-fixed')
      })
    }

    const observer = new MutationObserver(updateVueAffix)
    observer.observe(document.body, { childList: true, subtree: true })

    hideNavigation()
    updateVueAffix()

    window.addEventListener('scroll', updateVueAffix)
    window.addEventListener('resize', updateVueAffix)

    return () => {
      showNavigation()
      window.removeEventListener('scroll', updateVueAffix)
      window.removeEventListener('resize', updateVueAffix)
      observer.disconnect()
      const styleElement = document.getElementById('vue-affix-styles')
      if (styleElement) {
        styleElement.remove()
      }
    }
  }, [])

  return (
    <div className="flex flex-col gap-4" suppressHydrationWarning>
      <div id="volumecalculator" suppressHydrationWarning></div>
      <Script
        suppressHydrationWarning
        src={`/static_new/js/ve.js?v=${timestamp}`}
        strategy="afterInteractive"
      />
      <link
        suppressHydrationWarning
        rel="stylesheet"
        href={`/static_new/css/ve.css?v=${timestamp}`}
        key="vue-app-styles"
      />
    </div>
  )
}
